import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaEdit, FaTrash } from "react-icons/fa";

const TableAbouts = () => {
  const navigate = useNavigate();

  const [abouts, setAbouts] = useState([]);
  const [loading, setLoading] = useState(true);

  const [showDeletePrompt, setShowDeletePrompt] = useState(false);
  const [deleteAboutId, setDeleteAboutId] = useState(null);


  const fetchAbouts = async () => {
    try {
      setLoading(true);

      const response = await axios.get("/api_w/abouts", {
        headers: {
          db_name: process.env.REACT_APP_DB_NAME,
        },
      });

      console.log("DATA API ABOUTS:", response.data);

      const responseData = response.data;

      let data = [];

      if (Array.isArray(responseData)) {
        data = responseData;
      } else if (Array.isArray(responseData?.data)) {
        data = responseData.data;
      } else if (Array.isArray(responseData?.rows)) {
        data = responseData.rows;
      } else if (responseData?.data) {
        data = [responseData.data];
      }

      console.log("DATA ABOUTS YANG DITAMPILKAN:", data);

      setAbouts(data);
    } catch (error) {
      console.error("FETCH ABOUTS ERROR:", error);

      toast.error(
        "Error fetching abouts: " +
          (error.response?.data?.message ||
            error.response?.data?.error ||
            error.message)
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAbouts();
  }, []);


  const handleConfirmDelete = async () => {
    if (!deleteAboutId) return;

    try {
      await axios.delete(`/api_w/abouts/${deleteAboutId}`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          db_name: process.env.REACT_APP_DB_NAME,
        },
      });

      toast.success("Berhasil Hapus About");

      setAbouts((prev) =>
        prev.filter((about) => about.id !== deleteAboutId)
      );
    } catch (error) {
      console.error("DELETE ABOUT ERROR:", error);

      toast.error(
        "Gagal Hapus About: " +
          (error.response?.data?.message ||
            error.response?.data?.error ||
            error.message)
      );
    } finally {
      setShowDeletePrompt(false);
      setDeleteAboutId(null);
    }
  };

  const stripHtml = (html) => {
    if (!html) return "—";

    const tmp = document.createElement("div");
    tmp.innerHTML = html;

    return tmp.textContent || tmp.innerText || "—";
  };

  if (loading) {
    return (
      <div className="p-8 text-center">
        <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-brand-500 border-r-transparent" />
      </div>
    );
  }

  return (
    <div>
      <div className="overflow-x-auto">
        <table className="w-full text-left">
          <thead>
            <tr className="border-b border-gray-100 bg-gray-50">
              <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wider text-gray-400">
                No
              </th>

              <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wider text-gray-400">
                Media
              </th>

              <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wider text-gray-400">
                Judul
              </th>

              <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wider text-gray-400">
                Deskripsi
              </th>

              <th className="px-5 py-3 text-center text-xs font-semibold uppercase tracking-wider text-gray-400">
                Aksi
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-50">
            {abouts.length === 0 ? (
              <tr>
                <td
                  colSpan={5}
                  className="py-12 text-center text-sm text-gray-400"
                >
                  Belum ada data
                </td>
              </tr>
            ) : (
              abouts.map((about, index) => (
                <tr
                  key={about.id || index}
                  className="transition-colors hover:bg-gray-50/80"
                >
                  {/* NO */}
                  <td className="px-5 py-3 text-sm text-gray-500">
                    {index + 1}
                  </td>

                  {/* MEDIA */}
                  <td className="px-5 py-3">
                    {about.image_url ? (
                      <div className="h-12 w-16 overflow-hidden rounded-lg">
                        <img
                          src={about.image_url}
                          alt={about.title || "About"}
                          className="h-full w-full object-cover"
                        />
                      </div>
                    ) : about.video_url ? (
                      <div className="flex h-12 w-16 items-center justify-center overflow-hidden rounded-lg bg-black">
                        <video
                          src={about.video_url}
                          className="h-full w-full object-cover"
                          muted
                          controls={false}
                        />
                      </div>
                    ) : (
                      <span className="text-xs text-gray-400">—</span>
                    )}
                  </td>

                  {/* TITLE */}
                  <td className="px-5 py-3 text-sm font-semibold text-navy-700">
                    {about.title || "—"}
                  </td>

                  {/* BODY */}
                  <td className="max-w-xs px-5 py-3 text-sm text-gray-500">
                    <p className="line-clamp-2">
                      {stripHtml(about.body)}
                    </p>
                  </td>

                  {/* ACTION */}
                  <td className="px-5 py-3">
                    <div className="flex items-center justify-center gap-2">
                      {/* EDIT */}
                      <button
                        type="button"
                        onClick={() =>
                          navigate(`/admin/edit-abouts/${about.id}`)
                        }
                        className="flex h-8 w-8 items-center justify-center rounded-lg bg-blue-50 text-blue-500 transition-colors hover:bg-blue-100"
                      >
                        <FaEdit className="h-3.5 w-3.5" />
                      </button>

                      {/* DELETE */}
                      <button
                        type="button"
                        onClick={() => {
                          setDeleteAboutId(about.id);
                          setShowDeletePrompt(true);
                        }}
                        className="flex h-8 w-8 items-center justify-center rounded-lg bg-red-50 text-red-500 transition-colors hover:bg-red-100"
                      >
                        <FaTrash className="h-3.5 w-3.5" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* DELETE MODAL */}
      {showDeletePrompt && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="mx-4 w-full max-w-sm rounded-2xl bg-white p-6 shadow-2xl">
            <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-50">
              <FaTrash className="h-5 w-5 text-red-500" />
            </div>

            <h3 className="mb-2 text-lg font-bold text-navy-700">
              Hapus Data?
            </h3>

            <p className="mb-6 text-sm text-gray-500">
              Tindakan ini tidak dapat dibatalkan.
            </p>

            <div className="flex gap-3">
              <button
                type="button"
                onClick={() => {
                  setShowDeletePrompt(false);
                  setDeleteAboutId(null);
                }}
                className="flex-1 rounded-xl border border-gray-200 py-2.5 text-sm font-medium text-gray-600 hover:bg-gray-50"
              >
                Batal
              </button>

              <button
                type="button"
                onClick={handleConfirmDelete}
                className="flex-1 rounded-xl bg-red-500 py-2.5 text-sm font-bold text-white hover:bg-red-600"
              >
                Hapus
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TableAbouts;